import { millisecondsInHour } from "../constants/index.mjs";
import differenceInMilliseconds from "../differenceInMilliseconds/index.mjs";
import requiredArgs from "../_lib/requiredArgs/index.mjs";
import { getRoundingMethod } from "../_lib/roundingMethods/index.mjs";
function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(void 0)(diff);
}
export {
  differenceInHours as default
};
